export const PUBLIC_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'yahoo.co.uk',
    'yahoo.ca',
    'yahoo.fr',
    'hotmail.com',
    'hotmail.co.uk',
    'hotmail.fr',
    'outlook.com',
    'outlook.fr',
    'live.com',
    'live.fr',
    'msn.com',
    'aol.com',
    'icloud.com',
    'me.com',
    'mac.com',
    'mail.com',
    'protonmail.com',
    'zoho.com',
    'yandex.com',
    'gmx.com',
    'gmx.net',
    'fastmail.com',
    'comcast.net',
    'verizon.net',
    'att.net'
]